import { FC, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { signinAction, setErrorAction } from "../../redux/firebaseState/api";
import { RootState } from "../../redux/type";
import Message from "../UI/Message";
import Button from "../UI/Button";
import { currentAuth } from "../../redux/firebaseState/selectors";
import { useNavigate } from "react-router-dom";

export const LoginComponent: FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // New state for password visibility

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { error, success, authenticated } = useSelector<
    RootState,
    RootState["auth"]
  >(currentAuth);

  useEffect(() => {
    return () => {
      if (error) {
        dispatch(setErrorAction(""));
      }
    };
  }, [error, dispatch]);
  useEffect(() => {
    if (authenticated) {
      navigate("AfterLogin/newsletter", {});
    }
  }, [authenticated, navigate]);

  const submitHandler = (e: any) => {
    e.preventDefault();
    if (error) {
      console.log("error", error)
      dispatch(setErrorAction(""));
    }
    setLoading(true);
    dispatch(signinAction({ email, password }, () => setLoading(false)));
  };

  return (
    <div id="layoutAuthentication">
      <div id="layoutAuthentication_content">
        <main>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-5">
                <div className="card shadow-lg border-0 rounded-lg mt-5">
                  <div className="card-header">
                    <h3 className="text-center font-weight-light my-4">
                      Admin Login
                    </h3>
                    <p className="subtitle">
                      Please fill in your unique admin login details below
                    </p>
                  </div>

                  <div className="card-body">
                    <form onSubmit={submitHandler}>
                      {error && <Message type="danger" msg={"Invalid Credentials, Try again."} />}
                      <div className="mb-3">
                        <label htmlFor="inputEmail">Email Address</label>
                        <input
                          className="form-control"
                          id="inputEmail"
                          type="email"
                          placeholder="Enter Your Email Address"
                          onChange={(e) => setEmail(e.target.value)}
                          value={email}
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="inputPassword">Password</label>
                        <div className="d-flex"> 
                        <input
                          className="form-control"
                          id="inputPassword"
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter Your Password"
                          onChange={(e) => setPassword(e.target.value)}
                          value={password}
                          />    
                        <button
                          className="btn rounded-0 rounded-end"
                          type="button"
                          onClick={() => {
                            setShowPassword(!showPassword); // Toggle the password visibility
                          }}
                        >
                          {showPassword ? "Hide" : "Show"}
                        </button>
                        </div>
                      </div>
                      <div>
                        <p className="text-end px-2">
                           <a href="https://fernandesdriverman-cd237.web.app/forgotpassword">Forgot Password?</a>
                           {/* <a href="http://localhost:3000/forgotpassword">Forgot Password?</a> */}
                           </p>
                      </div>
                      <div className="d-flex align-items-center justify-content-between mt-4 mb-0">
                        <Button
                          text={loading ? "Loading..." : "Sign In"}
                          className="btn signBtn"
                          disabled={loading}
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};
